import type { ShareButtonProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const ShareButton = (props: ShareButtonProps) => {
  return <LazyComponent<ShareButtonProps> name="ShareButton" {...props} />;
};
